const roles = {
  SUPERUSER: {
    name: 'Superuser',
    hidden: true,
    roles: [
      'ADMIN'
    ],
    privileges: [
      'User.Create',
      'User.Read',
      'User.Update',
      'User.Delete',
      'Integration.Create',
      'Integration.Read',
      'Integration.Update',
      'Integration.Delete'
    ]
  },
  ADMIN: {
    name: 'Admin',
    roles: [
      'TECHNICAL',
      'CONTENT'
    ],
    privileges: [
      'AccountUser.Create',
      'AccountUser.Read',
      'AccountUser.Update',
      'AccountUser.Delete',
      'Integration.Read'
    ]
  },
  TECHNICAL: {
    name: 'Technical',
    privileges: [
      // Define any privileges the TECHNICAL role has access to
      'Page.Read',
      'Page.Update',
      'Integration.Read',
      'ImageOptimization.Read',
      'ImageOptimization.Update',
      'ImageOptimization.Delete'
    ],
    modules: []
  },
  CONTENT: {
    name: 'Content',
    privileges: [
      'File.Create',
      'File.Delete',
      'Page.Create',
      'Page.Read',
      'Page.Update',
      'Page.Delete',
      'Page.Publish',
      'PageUser.Create',
      'PageUser.Read',
      'PageUser.Update',
      'PageUser.Delete',
      'Integration.Read'
    ],
    modules: [
      'CONTENT'
    ]
  }
}

module.exports = roles
